// src/data/loadTranslations.js
import Papa from "papaparse";

/**
 * Lädt eine Übersetzungs-Datei public/data/translations/<langCode>.csv (id,text)
 * und gibt sie als Map(id -> text) zurück.
 */
export async function loadTranslations(langCode) {
  const response = await fetch(`/data/translations/${langCode}.csv`);
  if (!response.ok) {
    console.error(
      `[Fluent] Konnte /data/translations/${langCode}.csv nicht laden:`,
      response.status,
      response.statusText
    );
    return new Map();
  }

  const text = await response.text();
  const parsed = Papa.parse(text, { header: false, skipEmptyLines: true, quoteChar: '"', delimiter: "," });
  const rows = parsed.data || [];

  const map = new Map();
  for (const cols of rows) {
    if (!cols || cols.length < 2) continue;
    const id = cols[0]?.trim();
    const value = cols[1]?.trim();
    if (!id || !value) continue;
    map.set(id, value);
  }

  console.log(`[Fluent] Übersetzungen (${langCode}) geladen:`, map.size);
  return map;
}
